import { DescriptionCode, PaymentDirection } from '@lendica/utils';
import { TransactionCategory } from '../sharedTypes';

export const mapCodeToLabel = (code: DescriptionCode, paymentDirection: PaymentDirection) => {
    if (code === DescriptionCode.VendorDisburse) {
        return 'Vendor Disburse';
    } else if (code === DescriptionCode.CompanyDisburse) {
        if (paymentDirection === 'To Customer') {
            return TransactionCategory.Funding;
        } else {
            return TransactionCategory.Fees;
        }
    } else if (code === DescriptionCode.CompanyCollection) {
        return TransactionCategory.Repayment;
    }
};
